module.exports = __webpack_public_path__ + "static/media/service3.60faacba.svg";